import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  BASE_DOMAIN = environment.BASE_DOMAIN
  constructor(private api: ApiService, private http: HttpClient) { }

  addUpdateCustomer(payload: any): Observable<any> {
    const url = `${environment.New_BASE_DOMAIN}lms-service/account/addOrUpdate`;
    return this.api.post(url, payload);
  }
  addUpdateVendor(payload: any): Observable<any> {
    const url = `${environment.New_BASE_DOMAIN}lms-service/vendor/addOrUpdate`;
    return this.api.post(url, payload);
  }
  addUpdateEmployee(payload: any): Observable<any> {
    const url = `${environment.New_BASE_DOMAIN}lms-service/labour/addOrUpdate`;
    return this.api.post(url, payload);
  }
  getPincodeDetails(pincode:any): Observable<any> {
    const url = `${environment.New_BASE_DOMAIN}ams-utils-service/master/getPincode?pageNumber=0&pageSize=1`;
    const payload = [{key: 'PINCODE_IN', value: pincode}];
    return this.api.post(url, payload);
  }
   addUpdateUser(payload: any): Observable<any> {
    const url = `${environment.New_BASE_DOMAIN}lms-service/user/update`;
    return this.api.post(url, payload);
  }
  getCustomerDetails(payload:any, pageNumber:any,pageSize:any){
    const url = `${environment.New_BASE_DOMAIN}lms-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url, payload);
  }
  getVendorDetails(payload:any, pageNumber:any,pageSize:any){
    const url = `${environment.New_BASE_DOMAIN}lms-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url, payload);
  }
  getEmployeeDetails(payload:any, pageNumber:any,pageSize:any){
    const url = `${environment.New_BASE_DOMAIN}lms-service/labour/getLabourInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url, payload);
  }
  getStateDetails(){
    const url = `${environment.New_BASE_DOMAIN}ams-utils-service/master/getState?pageNumber=0&pageSize=50`;
    const payload: any[] = [];
    return this.api.post(url, payload);
  }
  upload(file: File): Observable<HttpEvent<any>> {
    var url :any
    const formData: FormData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders({
      'VER': '1',
      'DEVICE-TYPE':'Web'
    });
    // headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    url = `${environment.New_BASE_DOMAIN}ams-utils-service/uploads/uploadFiles`;
  
    const req = new HttpRequest('POST', url, formData, {
      headers,
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }
  getAllMasterCategory() {
    const url = `${environment.BASE_DOMAIN}ams-service/master/getAllMasterCategory`;
    return this.api.get(url);
  }
  getQuickCodeListByCategoryId(ids: any) {
    let url = `${environment.New_BASE_DOMAIN}ams-service/master/getQuickCodeListByCategoryId`
    if (ids) {
      url += `?categoryId=${ids}`;
    }
    return this.api.get(url);
  }

  getDistrictList(formData:any, pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ams-utils-service/master/getDistrict?pageNumber=${pageNumber}&pageSize=${pageSize}`;    
    return this.api.post(url, formData);
  }
}
